import { styled } from 'styled-components';

const HintContainer = styled.div`
  display: flex;
  min-width: 120px;
  padding: 12px;
  border-radius: 12px;
  box-sizing: border-box;
  background: #27262b;
  width: calc(100% - 36px);
  margin-left: 18px;
  margin-right: 18px;

  @media (min-width: 768px) {
    border-radius: 16px;
    min-width: 45%;
    flex-grow: 1;
    align-items: center;
  }
`;
const Hint = styled.p`
  margin: auto;
  color: #afafaf;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  //white-space: pre;
`;
const HintBold = styled.span`
  padding: 0 5px;
  color: #fff;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
`;

export { HintContainer, Hint, HintBold };
